jQuery( $ => {
    
    let headerHeight = document.getElementById('masthead').offsetHeight;
    let horizontalScrollBlocks = document.querySelectorAll( '.horizontal-scroll' );
    let panels = document.querySelectorAll( '.panel' );

    if( horizontalScrollBlocks ){
        horizontalScrollBlocks = Array.from(horizontalScrollBlocks);
        setSliderSize()
        $(window).on("scroll", handleScrollHorizontalBlock );
        $(window).on("resize", setSliderSize );
    }
    
    if( panels ){
        panels = Array.from(panels);
        $(window).on("scroll", handleScrollPanels );
    }

    function setSliderSize(){

        const isLargeScreen = $.screenSize('lg');

        horizontalScrollBlocks.forEach( block => {
            const slides = block.querySelectorAll('.card--block');
            const wrapper = block.querySelector('.scroll-wrapper');
            const total = slides.length;
            const size = (total + 1) * 500 + 400;
            const paddingBottom = isLargeScreen ? size - block.offsetWidth : 0;

            block.dataset.offset = $(block).offset().top - headerHeight;

            wrapper.style.width = isLargeScreen ? size + "px" : '';
            block.style.paddingBottom = paddingBottom + "px";
        })

    }

    function handleScrollHorizontalBlock(e){
        
        let scrollPos = $(window).scrollTop();
        const isLargeScreen = $.screenSize('lg');
        
        horizontalScrollBlocks.forEach(block =>{
            
            // Fix the slider

            let offsetTop = $(block).offset().top; // block position from top of page
            offsetTop = offsetTop - headerHeight

            if ( false == (scrollPos < offsetTop) ){
                block.classList.add('fixed');
            }else{
                block.classList.remove('fixed');
            }

            // Horizontal scroll

            const wrapper = block.querySelector('.scroll-wrapper');
            const height = $(block).height() + parseInt($(block).css("padding-bottom"));
            let initialOffset = parseFloat(block.dataset.offset);
            
            if( isLargeScreen ){
                let posX = Math.round( ( ( scrollPos - initialOffset ) / height ) * 100 ) * -1;
                posX = Math.min( posX, 0 ); // so it doesn't scroll right
                wrapper.style.transform = `translateX(${posX}%)`;
            }else{ // reset small scrren
                block.classList.remove('fixed');
                wrapper.style.transform = `translateX(0)`;
            }

        })

    }
    
    function handleScrollPanels(e){

        let scrollPos = $(window).scrollTop();
        
        panels.forEach( block =>{
            
            let offsetTop = $(block).offset().top; // block position from top of page
            offsetTop = offsetTop - headerHeight

            if ( false == (scrollPos < offsetTop) ){
                block.classList.add('fixed');
            }else{
                block.classList.remove('fixed');
            }
                        
            if( false == $.screenSize('lg') ){
                block.classList.remove('fixed');
            }
            
        })

    }

});